export const legalPages = [
  {
    slug: "mentions-legales",
    label: "Mentions légales",
    metaTitle: "Mentions légales — MSC Toitures | Couvreur 94",
    metaDescription:
      "Mentions légales du site MSC Toitures, entreprise de couverture à Champigny-sur-Marne (94500), Val-de-Marne.",
    h1: "Mentions légales",
    blocks: [
      {
        h2: "Éditeur du site",
        paragraphs: [
          "MSC Toitures — Entrepreneur individuel",
          "Siège social et showroom : 34 boulevard de Polangis, 94500 Champigny-sur-Marne",
          "Téléphone : 06 46 30 03 91 — 01 87 07 86 62",
          "Email : msctoitures@gmail.com",
          "SIREN : 911 038 271",
          "Directeur de la publication : Mayer Sayan",
        ],
      },
      {
        h2: "Hébergement du site",
        paragraphs: [
          "Ce site est conçu et hébergé via la plateforme Emergent (emergent.sh).",
          "Les coordonnées complètes de l'hébergeur seront précisées lors de la mise en ligne du site sur son nom de domaine définitif.",
        ],
      },
      {
        h2: "Propriété intellectuelle",
        paragraphs: [
          "L'ensemble des contenus présents sur ce site (textes, structure, éléments graphiques) est la propriété de MSC Toitures, sauf mention contraire. Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation écrite préalable est interdite.",
        ],
      },
      {
        h2: "Responsabilité",
        paragraphs: [
          "Les informations présentées sur ce site le sont à titre indicatif. MSC Toitures s'efforce d'en assurer l'exactitude et la mise à jour, sans pouvoir en garantir l'exhaustivité. L'entreprise ne saurait être tenue responsable des dommages directs ou indirects résultant de l'utilisation du site.",
        ],
      },
      {
        h2: "Données personnelles",
        paragraphs: [
          "Les informations collectées via le formulaire de devis sont traitées conformément à notre politique de confidentialité, consultable sur la page dédiée de ce site.",
        ],
      },
    ],
  },
  {
    slug: "politique-de-confidentialite",
    label: "Politique de confidentialité",
    metaTitle: "Politique de confidentialité — MSC Toitures | Protection des données",
    metaDescription:
      "Politique de confidentialité de MSC Toitures : collecte, utilisation et protection de vos données personnelles via le formulaire de devis.",
    h1: "Politique de confidentialité",
    blocks: [
      {
        h2: "Responsable du traitement",
        paragraphs: [
          "MSC Toitures — 34 boulevard de Polangis, 94500 Champigny-sur-Marne",
          "Téléphone : 06 46 30 03 91 — 01 87 07 86 62",
          "Email : msctoitures@gmail.com",
        ],
      },
      {
        h2: "Données collectées et finalité",
        paragraphs: [
          "Lorsque vous utilisez le formulaire de devis, nous collectons les informations suivantes : nom, numéro de téléphone, adresse email, ville, type de travaux souhaité, message libre et, si vous le souhaitez, une photo de votre toiture.",
          "Ces données sont utilisées exclusivement pour traiter votre demande de devis, vous recontacter et préparer notre intervention. Elles ne sont ni vendues, ni cédées à des tiers.",
        ],
      },
      {
        h2: "Base légale et durée de conservation",
        paragraphs: [
          "Le traitement repose sur l'exécution de mesures précontractuelles (votre demande de devis). Les données sont conservées pendant la durée nécessaire au traitement de votre demande, puis pendant une durée maximale de 3 ans à compter de notre dernier échange.",
        ],
      },
      {
        h2: "Vos droits",
        paragraphs: [
          "Conformément au Règlement général sur la protection des données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, d'effacement, d'opposition, de limitation et de portabilité de vos données.",
          "Pour exercer ces droits, écrivez-nous à msctoitures@gmail.com ou par courrier à l'adresse du siège. Vous pouvez également introduire une réclamation auprès de la CNIL (cnil.fr).",
        ],
      },
      {
        h2: "Cookies et mesure d'audience",
        paragraphs: [
          "Ce site utilise un outil de mesure d'audience permettant d'établir des statistiques de visite anonymisées (pages consultées, parcours de navigation). Aucune donnée de navigation n'est utilisée à des fins publicitaires.",
        ],
      },
      {
        h2: "Sécurité",
        paragraphs: [
          "Nous mettons en œuvre des mesures techniques raisonnables pour protéger vos données (connexion chiffrée HTTPS, accès limité aux informations transmises).",
        ],
      },
    ],
  },
];
